import { render, staticRenderFns } from "./HeadlineWithTextAndImageV2.vue?vue&type=template&id=0c41dc6a&"
import script from "./HeadlineWithTextAndImageV2.vue?vue&type=script&lang=js&"
export * from "./HeadlineWithTextAndImageV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseHeading: require('/usr/src/app/components/base/Heading.vue').default,BaseBtn: require('/usr/src/app/components/base/Btn.vue').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VLazy,VRow})
